<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="listOptions"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :placeholder="placeholder"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="allDocumentsState.loading"
          :style="{ opacity: allDocumentsState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay tipos de documentos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('List', [
      'allDocumentsState'
    ]),
    optionSelected() {
      return this.allDocumentsState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.allDocumentsState.list.length
        || this.allDocumentsState.loading;
    },
    listOptions() {
      if (this.typeNumeration === 'numOf') {
        return this.allDocumentsState.list
          .filter((document) => document.extra.numOf);
      }
      if (this.typeNumeration === 'numInt') {
        return this.allDocumentsState.list
          .filter((document) => document.extra.numInt);
      }

      if (this.usage) {
        return this.allDocumentsState.list
          .filter((doc) => doc.deshabilitado === 0)
          .filter((document) => document.extra.uso && document.extra.uso[this.usage]);
      }
      return this.allDocumentsState.list;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchAllDocuments'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
      this.$emit('input-option', event);
    },
    getOption() {
      return this.allDocumentsState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchAllDocuments();
  },
  props: {
    usage: { type: String },
    name: { type: String, required: true },
    label: { type: String, default: 'Tipo Documento' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    typeNumeration: { type: String },
    placeholder: { type: String }
  }
};

</script>
